import React, { createContext, useContext } from "react";

type PortalContainer = Element | DocumentFragment | null;

const PortalContainerContext = createContext<PortalContainer>(null);

export function PortalContainerProvider({
	container,
	children,
}: {
	container: PortalContainer;
	children: React.ReactNode;
}) {
	return <PortalContainerContext.Provider value={container}>{children}</PortalContainerContext.Provider>;
}

export function usePortalContainer(): PortalContainer {
	return useContext(PortalContainerContext);
}
